import { CommonCallout } from 'components/common/callouts';

export const NoCsvCallout = () => (
  <CommonCallout text="common.upload-a-csv-file-first" />
);
